export enum AvailableLanguages {
  DUTCH = 'nl',
  FRENCH = 'fr',
  GERMAN = 'de',
  ENGLISH = 'en',
}
